import { Action } from '@ngrx/store';
import {AccountMgtListFilter} from '../account.model';

export enum AccountMgtListFilterActionTypes {
  LoadAccountMgtListFilters = '[AccountMgtListFilter] Load AccountMgtListFilters',
  SelectAccountMgtListFilters = '[AccountMgtListFilter] Select AccountMgtListFilters',
}

export class LoadAccountMgtListFilters implements Action {
  readonly type = AccountMgtListFilterActionTypes.LoadAccountMgtListFilters;
}

export class SelectAccountMgtListFilters implements Action {
  readonly type = AccountMgtListFilterActionTypes.SelectAccountMgtListFilters;
  constructor(public payload: AccountMgtListFilter) {}
}


export type AccountMgtListFilterActions = LoadAccountMgtListFilters
  | SelectAccountMgtListFilters;
